export default __webpack_public_path__ + "static/media/Bank of Naboo-logos.4e2f60aa.jpeg";